import React, { Component } from "react";
import platform from "Pub/js/platform";
import { PageLayout, PageLayoutHeader } from "Components/PageLayout";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import { getStore } from "Pub/js/storageUtils";
import { getMulti } from "Pub/js/getMulti";
import metaJson from "./meta.js";
import buttons from "./buttons.js";
import "./index.less";
import { changeError } from "Store/appStore/action";
import defaultIcon from "Pub/js/defaultIcon";
// import Notice from "Components/Notice";
import { connect } from "react-redux";
const { createPage, base, toast, pageTo, high } = platform;
const { NCButton, NCDiv, NCRangePickerClient, NCFormControl, NCTooltip } = base;
const { BillErrorTrack } = high;

let preBillgroup = []; // 之前单据号数组

function unique(arr) {
    return Array.from(new Set(arr))
}

class ErrorCenter extends Component {
    constructor(props) {
        super(props);
        props.use.table('table'); //2020.12版本使用platform组件新写法
        const _this = this;
        // 时间插插件处理start
        const dateStr = new Date();
        let year = dateStr.getFullYear();
        let Dates = dateStr.getDate();
        let Month = dateStr.getMonth() + 1;
        let predateStr = new Date(dateStr.getTime() - 1000 * 60 * 60 * 24 * 30);
        let year1 = predateStr.getFullYear();
        let Dates1 = predateStr.getDate();
        let Month1 = predateStr.getMonth() + 1;
        // 时间插插件处理end

        this.state = {
            langJson: {},
            v: [year1 + '-' + (Month1 < 10 ? '0' + Month1 : Month1) + '-' + (Dates1 < 10 ? '0' + Dates1 : Dates1), year + '-' + (Month < 10 ? '0' + Month : Month) + '-' + (Dates < 10 ? '0' + Dates : Dates)],
            serviceDateIndex: 0,
            serviceDatearr: ['all', 'today', '7date'],
            // 单据类型数据
            billgroup: [],
            billgroupIndex: -1,

            // 发起方单据编号
            sendbillcode: '',

            // 展示数组
            gridarr: [],
            totalPage: '',
            total: '',

            billpk: '',
            billtype: '',
            gtxid: '',
            showBillTrack: false,
        };
        // 多语的回调函数处理设置表格json结构模板，（初始化表格）表格操作列、超链接。
        let callback = json => {
            this.state.langJson = json;
            let renderopr = (text, record, index) => {
                let optionArr = [];
                if (record.billmaker4.track == 1) {
                    optionArr.push("orderback"); // 订单追溯；
                }
                if (record.billmaker4.compensable == 1) {
                    optionArr.push("return"); // 回退；
                }
                if (record.billmaker.retry == 1) {
                    optionArr.push("retry"); // 重试；
                }
                return (
                    <div>
                        {props.button.createOprationButton(
                            optionArr,
                            {
                                rowIndex: index,
                                area: "table_row",
                                buttonLimit: 3,
                                onButtonClick: (props, id, e, index) => {
                                    _this.optButtonHandle(props, id, e, index, record);
                                },
                                // popContainer: document.querySelector(
                                //     ".header2"
                                // ),
                            }
                        )}
                    </div>
                );
            }

            const render = (text={}, record, index) => {
                // 多个单据号，表格展示第一个，其余的下拉展示
                const billNoStr = text && (text.value);
                const billNoArr = unique((billNoStr && billNoStr.split(',')) || []);
                const billNo = billNoArr[0];

                // 多个单据类型：链接不可点击
                const billtype = text && ((text.tradeType) || (text.billtype));
                const billtypeArr = unique((billtype && billtype.split(',')) || []);

                let showlink = true;
                //单据号包含";" 或者单据类型包含";" 单据号列都不能渲染成超链接
                if ((typeof billNo === 'string' && typeof text.billtype === 'string') && (billNo.includes(';') || text.billtype.includes(';'))) {
                    showlink = false;
                }

                const hyperlink = text && (text.hyperlink - 0);
                // 下拉出现
                const liststatus = text && text.liststatus;
                const pathModule = text && text.module;
                // 下拉方向、朝向，
                const updown = text && text.updown;
                if (billNoArr.length > 1) { // 多个单据号或者多个单据类型，不可点击；只有一个单据号 且一个单据类型时，才可以点击跳转详情
                    return <NCTooltip
                        className="high-table-tooltip"
                        placement="bottom"
                        overlay={<div className="billnolistbox-innerbox">
                            {billNoArr.map((e, i) => {
                                {/* 单据类型只有1个才可能能点击 */ }
                                if ((billtypeArr.length < 2 && showlink) && hyperlink) {
                                    let billpk = text.trackBillPks || text.billpk;
                                    billpk = billpk && billpk.split(',');
                                    billpk = (billpk && billpk[i]) || (billpk[0]) || '';
                                    let billtype1 = billtypeArr[0];
                                    return (<div className="billnolistitem"><a onClick={() => {
                                        pageTo.openAppByBilltype({
                                            billpk: billpk,
                                            billtype: billtype1,
                                            type: 'open',
                                            pathModule: pathModule,
                                        })
                                    }} >
                                        {text && text.value && e}
                                    </a></div>)
                                } else {// 多个单据类型不可点击
                                    return (<div className="billnolistitem" onClick={() => toast({ content: langCheck("ErrorCenter-0000021", "pages", json), color: 'warning' })}>{e}</div>)
                                }

                            })}
                        </div>}
                    >
                        <div
                            className="billnolistcontainer">
                            {/* 单据类型只有1个才可能能点击 */}
                            {((billtypeArr.length < 2 && showlink) && hyperlink) ?
                                <a onClick={() => {
                                    let billpk = text.trackBillPks || text.billpk;
                                    billpk = billpk && billpk.split(',')[0];
                                    let billtype = billtypeArr[0];
                                    pageTo.openAppByBilltype({
                                        billpk,
                                        billtype,
                                        type: 'open',
                                        pathModule: pathModule,
                                    })
                                }} >
                                    {text && text.value && billNo}

                                </a> :
                                <span className="billnospan" onClick={() => toast({ content: langCheck("ErrorCenter-0000021", "pages", json), color: 'warning' })} alt={billNo}>{billNo}</span>
                            }
                            {(billNoArr.length > 1) ? <span className="billnonum">+{billNoArr.length}</span> : null}
                        </div >
                    </NCTooltip >;
                } else {// 单个单据号
                    return (
                        (billtypeArr.length < 2 && showlink) && hyperlink ? (<a onClick={() => {
                            let billpk = text && (text.trackBillPks || text.billpk);
                            let billtype = text && ((text.tradeType) || (text.billtype));
                            pageTo.openAppByBilltype({ billpk, billtype, type: 'open', pathModule: pathModule });
                        }} >
                            {text && text.value && billNo}

                        </a>) : <span>{text && text.value && billNo}</span>
                    );
                }
            }
            // 模板修改
            metaJson.table.items[1]['render'] = render;
            metaJson.table.items[6]['render'] = renderopr;
            metaJson.table.name = langCheck("ErrorCenter-000000", "pages", json);
            // 重试回退的确认弹窗
            props.button.setPopContent("return", langCheck("ErrorCenter-0000017", "pages", json));
            // props.button.setPopContent("retry", langCheck("ErrorCenter-0000018", "pages", json));
            // 列表表头多语处理
            for (let i = 25; i < 32; i++) {
                metaJson.table.items[i - 25].label = langCheck(("ErrorCenter-00000" + i), "pages", json);
            }
            // button多语处理。
            for (let i = 14; i < 17; i++) {
                buttons[i - 14].title = langCheck(("ErrorCenter-00000" + i), "pages", json);
            }
            props.button.setButtons(buttons);
            props.meta.setMeta(metaJson, () => { });
        };
        getMulti({ moduleId: "ErrorCenter", domainName: "workbench", callback });
    }
    // 获取单据类型接口
    getBillTypeData(callback, pageIndex) {
        const { langJson } = this.state;
        Ajax({
            url: '/nccloud/platform/fixdata/ListFixDataBillTypeAction.do',
            data: {},
            info: {
                name: langCheck("ErrorCenter-000000", "pages", langJson),
                action: langCheck("ErrorCenter-0000019", "pages", langJson),
                appcode: "10220PLOGG"
            },
            success: (result) => {
                var billgroup = [];
                var billgroupIndex = this.state.billgroupIndex;
                if (result && result.data && result.data.success) {
                    billgroup = result.data.data || [];
                    // 判断分类数是否变化!
                    if (billgroup.length !== preBillgroup.length) {
                        preBillgroup = billgroup;
                        billgroupIndex = -1;
                        pageIndex = 1;
                    }
                    this.setState({ billgroup, billgroupIndex }, () => {
                        this.props.table.updateTableHeight('table');
                        this.loadgrid(callback, pageIndex);
                    });
                }
            }
        });
    }
    // 点击切换单据类型active状态
    billtypehandle(index) {
        this.setState({ billgroupIndex: index }, () => {
            this.loadgrid(null, 1);
        });
    }
    // 发起业务方日期切换
    seviceDateHandle(index, value) {
        if (index < 3) { // 全部、今日、近7天
            this.setState({
                serviceDateIndex: index
            }, () => {
                this.loadgrid(null, 1);
            })
        } else {  // 日期组件
            if (!value) { // 日期清空情况下
                this.setState({
                    serviceDateIndex: 0,
                    v: null
                }, () => {
                    this.loadgrid(null, 1);
                })
            } else { // 日期重新选择  
                if (this.state.v && (value.toString() == this.state.v.toString())) { // 选择日期和之前一致
                    return;
                } else { // 选择日期和之前不一致
                    this.setState({
                        serviceDateIndex: 3,
                        v: value
                    }, () => {
                        this.loadgrid(null, 1);
                    })
                }
            }
        }
    }
    //  单据号事件输入显示
    billCodeHandle(value) {
        this.setState({ sendbillcode: value });
    }
    //  单据号查询事件
    billCodeBlur = () => {
        const { langJson } = this.state;
        this.loadgrid((e) => {
            // 查询到为非0
            if (e > 0) {
                toast({ content: langCheck("ErrorCenter-0000022", "pages", langJson) + e + langCheck("ErrorCenter-0000023", "pages", langJson) });
            }
            // 查询到为非0 
            if (e == 0) {
                toast({ content: langCheck("ErrorCenter-0000024", "pages", langJson), color: 'warning' });
            }
        }, 1);
    }
    // 表格数据请求
    loadgrid = (callback, pageIndex) => {
        // 日期，时间区间，单号编码，单号类型;
        const { serviceDateIndex, serviceDatearr, v, sendbillcode, billgroupIndex, billgroup, langJson } = this.state;
        let data = {};
        let { getTablePageInfo } = this.props.table;
        let TablePageInfo = getTablePageInfo('table');
        // let pageIndex = TablePageInfo.pageIndex;

        data.start = pageIndex + '';
        data.pageSize = TablePageInfo.pageSize + '';
        // 全部今日近7天
        if (serviceDateIndex < 3) { // 全部今日近7天
            data.datetype = serviceDatearr[serviceDateIndex];
        }
        // 日期时间段
        if (serviceDateIndex == 3) { // 日期选择；
            data.startdate = v[0];
            data.enddate = v[1];
        }
        // 单号
        if (sendbillcode) {
            data.billno = sendbillcode;
        }
        // 单据类型
        if (billgroupIndex == -1) {
            // data.billtype = 'all';
        } else {
            data.billtype = billgroup[billgroupIndex].billtypecode;
        }
        Ajax({
            url: '/nccloud/platform/fixdata/ListFixDataAction.do',
            data: data,
            info: {
                name: langCheck(
                    "ErrorCenter-000000",
                    "pages",
                    langJson
                ),
                action: langCheck(
                    "ErrorCenter-0000020",
                    "pages",
                    langJson
                ),
                appcode: "10220PLOGG"
            },
            success: (result) => {
                if (result.data.success) {
                    this.setState({
                        gridarr: result.data.data.data,
                        // totalPage: result.data.data.pageinfo.totalpage,
                        // total: result.data.data.pageinfo.totalnum
                    });
                    pageIndex--;
                    // this.setSimpleTab(result.data.data.data, pageIndex, data.pageSize, result.data.data.pageinfo.totalpage, result.data.data.pageinfo.totalnum);
                    this.setSimpleTab(result.data.data.data, pageIndex, data.pageSize);
                }
                if (Object.prototype.toString.call(callback) == "[object Function]") {
                    callback(result.data.data.data.length);
                }
            }
        });
    }
    // 模板更改表格数据
    setSimpleTab(arr, pageIndex, pageSize) {
        let { setAllTableData } = this.props.table;
        let res = {
            success: true,
            message: "",
            table: {
                allpks: [], //自己编的pks
                pageInfo: {
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    // total: totalnum,
                    // totalPage: totalPage
                },
                rows: [
                    {
                        rowId: "3334555qqqqq555",
                        status: "0",
                        values: {
                            billmaker: {
                                value: "2016-05-20 14:51:48"
                            },
                            billmaker1: {
                                value: "17"
                            },
                            billmaker2: {
                                value: "2016-06-20 14:58:46"
                            },
                            billmaker3: {
                                value: "0001K710000000004DSE",
                                //display: "回忆落空了残年"
                            },
                            billmaker4: {
                                value: "2016-06-20 14:58:46"
                            }
                        }
                    },
                    {
                        rowId: "3334555qqqqq555",
                        status: "0",
                        values: {
                            billmaker: {
                                value: "2016-05-20 14:51:48"
                            },
                            billmaker1: {
                                value: "18"
                            },
                            billmaker2: {
                                value: "2016-06-20 14:58:46"
                            },
                            billmaker3: {
                                value: "0001K710000000004DSE",
                                display: ""
                            },
                            billmaker4: {
                                value: "2016-06-20 14:58:46"
                            }
                        }
                    }
                ]
            }
        };
        res.table.rows.length = 0;
        for (var i = 0; i < arr.length; i++) {
            const businessPk = arr[i].businessPk;
            const hyperlink = arr[i].hyperlink;
            const retry = arr[i].retry;
            const businessDate = arr[i].businessDate && arr[i].businessDate.length && arr[i].businessDate.split(' ')[0];
            res.table.rows.push({
                //rowId: i, //去掉rowid 使用simpleTable内置方法的随机数，解决数据偶发不更新问题
                status: "0",
                values: {
                    // 错误消息
                    billmaker: {
                        value: arr[i].errorMsg_desc,
                        gtx_id: arr[i].gtxid,
                        billpkccc: businessPk,
                        hyperlink: hyperlink,
                        retry: retry,
                        module: arr[i].module,
                    },
                    // 发起方单据号
                    billmaker1: {
                        value: arr[i].billNo,
                        billpk: businessPk,
                        billtype: arr[i].billType,
                        tradeType: arr[i].tradeType,
                        trackBillPks: arr[i].trackBillPks,
                        hyperlink: hyperlink,
                        billtype_name: arr[i].billtype_name,
                        liststatus: arr[i].liststatus,
                        updown: arr[i].updown,
                        module: arr[i].module,
                    },
                    // 单据类型
                    billmaker2: {
                        value: arr[i].billtype_name,
                        module: arr[i].module,
                    },
                    // 交易类型
                    billmaker3: {
                        value: arr[i].tradeType_name,
                        module: arr[i].module,
                    },
                    // 操作类型
                    billmaker4: {
                        value: arr[i].operation,
                        compensable: arr[i].compensable,
                        track: arr[i].track,
                        retry: retry,
                        module: arr[i].module,
                    },
                    // 业务日期
                    billmaker5: {
                        value: businessDate,
                        compensable: arr[i].compensable,
                        track: arr[i].track,
                        module: arr[i].module,
                    }
                }
            })
            res.table.allpks.push(businessPk);
        }
        setAllTableData("table", res.table);
    }
    // 操作按钮， 重试，回退。
    optButtonHandle(props, id, e, index, record) {
        let url = '', data = {};
        if (id == 'retry') {
            url = '/nccloud/platform/fixdata/ResetFixDataAction.do';
            data.gtxid = [record.billmaker.gtx_id];
        }
        if (id == 'return') {
            url = '/nccloud/platform/fixdata/BackFixDataAction.do';
            data.gtxid = record.billmaker.gtx_id;
        }
        if (id == 'orderback') {
            let gtxid = record.billmaker.gtx_id;
            let billpk = record.billmaker1.billpk;
            let billtype = record.billmaker1.billtype;
            let billtypeArr = unique((billtype && String(billtype).split(',')) || []);
            let billpkArr = unique((billpk && String(billpk).split(',')) || []);
            let errorViewType = true;
            if (billtypeArr.length > 1 || billpkArr.length > 1) {
                errorViewType = 'none';
            }
            this.setState({ showBillTrack: true, gtxid: gtxid, billpk: billpk, billtype: billtype, errorViewType: errorViewType })
            return
        }
        Ajax({
            url: url,
            data: data,
            info: {
                name: langCheck(
                    "OwnLog-000013",
                    "pages",
                    //langJson
                ) /* 国际化处理： 首页*/,
                action: langCheck(
                    "OwnLog-000003",
                    "pages",
                    // langJson
                ) /* 国际化处理： 首页加载*/,
                appcode: "10220PLOGG"
            },
            success: (result) => {
                if (id == 'return') {// 回退
                    const { langJson } = this.state;
                    const returns = langCheck("ErrorCenter-0000012", "pages", langJson);
                    toast({ content: returns });
                }
                if (id == 'retry') {// 回退
                    const { langJson } = this.state;
                    const retry = langCheck("ErrorCenter-0000011", "pages", langJson);
                    toast({ content: retry });
                }
            },
        });

    }
    // 刷新成功提示
    show() {
        const { langJson } = this.state;
        const refesh = langCheck("ErrorCenter-0000010", "pages", langJson);
        let { getTablePageInfo } = this.props.table;
        let TablePageInfo = getTablePageInfo('table');
        let pageIndex = TablePageInfo.pageIndex + 1;
        this.getBillTypeData(() => { toast({ content: refesh }) }, pageIndex);
    }
    // 渲染前调用,
    componentWillMount = () => {
    };
    // 渲染后调用,
    componentDidMount() {
        this.getBillTypeData(null, 1);
        document.addEventListener("visibilitychange", this.visibilitychangeHandle);
        document.addEventListener("keydown", this.keydownHangle, false);
    }
    keydownHangle = (e) => {
        if (e.keyCode == 116) {
            e.preventDefault();
            //要做的其他事情
            this.show();
        }
    }
    visibilitychangeHandle = () => {
        if (document.visibilityState === 'visible') {
            let { getTablePageInfo } = this.props.table;
            let TablePageInfo = getTablePageInfo('table');
            let pageIndex = TablePageInfo.pageIndex + 1;
            this.getBillTypeData(null, pageIndex);
        }
    }
    componentWillUnmount() {
        document.removeEventListener("visibilitychange", this.visibilitychangeHandle);
        document.removeEventListener("keydown", this.keydownHangle);
    }
    // 分页信息点击事件
    pageInfoChange = (props, config, pks, total) => {
        let { getTablePageInfo } = this.props.table;
        let TablePageInfo = getTablePageInfo('table');
        let pageIndex = TablePageInfo.pageIndex + 1;
        this.loadgrid(null, pageIndex);
        let { errorFlag, changeError } = this.props;
        changeError(!errorFlag);
    }
    componentWillReceiveProps(props) {
        const dateStr = new Date();
        let year = dateStr.getFullYear();
        let Dates = dateStr.getDate();
        let Month = dateStr.getMonth() + 1;
        let predateStr = new Date(dateStr.getTime() - 1000 * 60 * 60 * 24 * 30);
        let year1 = predateStr.getFullYear();
        let Dates1 = predateStr.getDate();
        let Month1 = predateStr.getMonth() + 1;

        // 时间插件重置
        this.setState({
            //v: [year1 + '-' + Month1 + '-' + Dates1, year + '-' + Month + '-' + Dates],
            v: [year1 + '-' + (Month1 < 10 ? '0' + Month1 : Month1) + '-' + (Dates1 < 10 ? '0' + Dates1 : Dates1), year + '-' + (Month < 10 ? '0' + Month : Month) + '-' + (Dates < 10 ? '0' + Dates : Dates)],
            serviceDateIndex: 0,
            billgroupIndex: -1,
            sendbillcode: ''  // 发起方单据编号
        }, (preval) => {
            let { getTablePageInfo } = this.props.table;
            let TablePageInfo = getTablePageInfo('table');
            let pageIndex = TablePageInfo.pageIndex + 1;
            this.loadgrid(null, pageIndex);
        })
        //this.loadgrid();
        // changeError(false);
    }
    webstocketdatahandle = (resMessage) => {
        // console.log(resMessage, 'This is webstocket information print');
        let { getTablePageInfo } = this.props.table;
        let TablePageInfo = getTablePageInfo('table');
        let pageIndex = TablePageInfo.pageIndex + 1;
        this.getBillTypeData(null, pageIndex);
        /*
           {
               "type": "saga_error",
               "error": true, // true失败 false成功
               "msg": "报错了e",
           }
           {
               "type": "saga_hint",
               "error": true, // true失败 false成功
               "msg": "报错了e",
           }
         */
    }
    render() {
        const { langJson } = this.state;
        const { table, socket } = this.props;
        const { createSimpleTable } = table;
        const { billgroup } = this.state;
        let { errorFlag, changeError } = this.props;
        const _this = this;
        const iconType = getStore("nccIcon") || "";

        return (
            <div className="page-error-center">
                <PageLayout
                    header={
                        <PageLayoutHeader>
                            <div className="pageLayoutHeaderOwn">
                                {
                                    socket.connectMesg({
                                        onMessage: (props, resMessage) => {
                                            console.log(resMessage)
                                            if (resMessage) {
                                                changeError(!errorFlag);
                                                _this.webstocketdatahandle(resMessage)
                                            }

                                        }
                                    })
                                }
                                {/* <div onClick={()=>{_this.webstocketdatahandle()}}>点我</div> */}
                                <img className='page-title-Icon' src={defaultIcon[iconType] ? defaultIcon[iconType] : defaultIcon["defaultIcon"]} />
                                <NCDiv fieldid={langCheck("ErrorCenter-000000", "pages", langJson)} areaCode={NCDiv.config.Title}>
                                    {langCheck("ErrorCenter-000000", "pages", langJson)}{/* 国际化处理： 事务错误中心*/}
                                </NCDiv>
                            </div>
                            <div className="fresh-btn"><NCTooltip placement="bottom" overlay="F5"><NCButton fieldid="refresh" colors="secondary" shape="icon" onClick={this.show.bind(this)}><i className="iconfont icon-shuaxin1" /></NCButton></NCTooltip></div>
                        </PageLayoutHeader>
                    }>
                    <div>
                        <BillErrorTrack show={this.state.showBillTrack} close={() => { this.setState({ showBillTrack: false }) }} pk={this.state.billpk} type={this.state.billtype} gtxid={this.state.gtxid} errorViewType={this.state.errorViewType} />
                        <div className="search-topline">
                            <span className="service-data">{langCheck("ErrorCenter-000001", "pages", langJson)}{/* 国际化处理： 发起业务方日期*/}：</span>
                            <span className={this.state.serviceDateIndex == 0 ? "all-time active-status" : "all-time"} onClick={this.seviceDateHandle.bind(this, 0)}>{langCheck("ErrorCenter-000002", "pages", langJson)}{/* 国际化处理： 全部*/}</span>
                            <span className={this.state.serviceDateIndex == 1 ? "today-time active-status" : "today-time"} onClick={this.seviceDateHandle.bind(this, 1)}>{langCheck("ErrorCenter-000003", "pages", langJson)}{/* 国际化处理： 今日*/}</span>
                            <span className={this.state.serviceDateIndex == 2 ? "seven-day active-status" : "seven-day"} onClick={this.seviceDateHandle.bind(this, 2)}>{langCheck("ErrorCenter-000004", "pages", langJson)}{/* 国际化处理： 近7天*/}</span>
                            <div className="item datepicker-box">
                                {/* 国际化处理： 开始 结束*/}
                                <NCRangePickerClient
                                    placeholder={langCheck("ErrorCenter-000005", "pages", langJson) + '~' + langCheck("ErrorCenter-000006", "pages", langJson)}
                                    //format='YYYY-MM-DD'
                                    showTimeFunction={false}
                                    value={this.state.v}
                                    onChange={this.seviceDateHandle.bind(this, 3)}
                                    showClear={true}
                                    fieldid="dateRange" //自动化测试标记
                                />
                            </div>
                            <span className="send-bill">{langCheck("ErrorCenter-000007", "pages", langJson)}{/* 国际化处理： 发起方单据编号*/}：</span>
                            <span className="bill-inpt"><NCFormControl fieldid="billno" type="search" placeholder={langCheck("ErrorCenter-000008", "pages", langJson)} value={this.state.sendbillcode} onChange={this.billCodeHandle.bind(this)} onKeyDown={(e) => { e = e || window.event; if (e.keyCode == 13) { this.billCodeBlur() } }} />{/*国际化处理： 请按照标准输入*/}</span>
                            <NCButton className="serach-btn" colors="primary" onClick={this.billCodeBlur}>{langCheck("ErrorCenter-0000032", "pages", langJson)}</NCButton>
                        </div>
                        <div className="search-topline bill-type-contanier">
                            <span className="bill-typename" >{langCheck("ErrorCenter-000009", "pages", langJson)}{/* 国际化处理： 发起方单据类型*/}：</span>
                            <div className="bill-type-buttons">
                                <span className={this.state.billgroupIndex == -1 ? "bill-type active-status" : "bill-type"} onClick={this.billtypehandle.bind(this, -1)}>{langCheck("ErrorCenter-000002", "pages", langJson)}{/* 国际化处理： 全部*/}</span>
                                {
                                    billgroup.map((e, index) => {
                                        return <span className={this.state.billgroupIndex == index ? "bill-item active-status" : "bill-item"} onClick={this.billtypehandle.bind(this, index)}>{e && (e.billtypename + e.billtypecount)}</span>
                                    })
                                }
                            </div>
                        </div>
                        <div className="table-box">
                            <div className="nc-singleTable-table-area" >
                                {createSimpleTable('table', {
                                    showIndex: false,
                                    showCheck: false,
                                    fieldid: 'error', //自动化测试标记，勿删
                                    cancelCustomRightMenu: true,
                                    showPagination: false,
                                    handlePageInfoChange: this.pageInfoChange
                                })}
                            </div>
                        </div>
                    </div>
                </PageLayout>
            </div>

        );
    }
}
const ErrorCenterInfo = createPage({})(ErrorCenter);
export default connect(
    state => ({
        errorFlag: state.appData.errorFlag,
        //businessDate: state.appData.businessDate
    }),
    { changeError }

)(ErrorCenterInfo);